import React from 'react';
import { Chip } from 'src/components/PulseUI';
import { COLOR_MAP } from 'src/utils/constants/scss-variables.constants';
import { textColorBasedOnBg } from 'src/utils/color.helpers';

interface TagProps {
  tag: {
    id: number;
    FormattedText?: () => React.JSX.Element;
    fullText?: string;
    bgColor?: string;
    bg_color?: string;
    color?: string;
    href?: string;
    taggable_type?: string;
    name?: string;
  };
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
}

const Tag: React.FC<TagProps> = ({
  tag,
  size = 'sm',
  className = '',
  onClick,
}) => {
  const bg = tag.bg_color || COLOR_MAP['gray-lightest'];

  return (
    <Chip
      size={size}
      variant="outlined"
      className={`
          overflow-hidden
          ${className}
        `}
      style={{
        backgroundColor: bg,
        color: tag.color || textColorBasedOnBg({ bgHex: bg }),
        maxWidth: '100%',
      }}
      onClick={onClick}
    >
      <span className="text-[.65rem] font-medium">
        {tag.name?.toUpperCase()}
      </span>
    </Chip>
  );
};

export default Tag;
